import { Box } from "@mui/material"
import { useMeasurement } from "lib/@hooks/useMeasurement"
import { TaskOrHeader } from "routes/schedule/tasks/taskOrHeader"
import { AuthoringSideBySideRow } from "./authoring-side-by-side-row"

export function AuthoringCompareMissingTask({ task }) {
    const [{ width, height }, attach] = useMeasurement()

    return (
        <AuthoringSideBySideRow
            dataCy={`side-by-side-task-row-${task.id}`}
            left={<LeftPlaceholder width={width} height={height} />}
            right={
                <Box ref={attach}>
                    <TaskOrHeader last={true} item={task} />
                </Box>
            }
        />
    )
}

function LeftPlaceholder({ width, height }) {
    return (
        <Box py={1}>
            <Box
                borderRadius={1}
                width={width}
                minWidth={180}
                p={1}
                height={height}
                minHeight={80}
                textAlign="center"
                alignItems="center"
                bgcolor="action.selected"
                display="flex"
                justifyContent="center"
            >
                Not found in this version
            </Box>
        </Box>
    )
}
